<template>
  <tr class="table-row" :class="[variant]">
    <slot></slot>
  </tr>
</template>

<script>
export default {
  name: "TableRow",
  props: {
    variant: { type: String, default: "" },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.table-row {
  width: 100%;
}
</style>
